import React from 'react';
import { BrowserRouter, Routes, Route, useLocation} from 'react-router-dom';
import { useEffect } from "react";
import { initGA, logPageView } from "./../analytics";


import { HomePage } from '../pages/HomePage/HomePage';
import { Nutrition } from '../pages/Nutrition/Nutrition';
import { Exercises } from '../pages/Exercises/Exercises';
import { MindBody } from '../pages/MindBody/MindBody';
import { Products } from '../pages/Products/Products';
import { News } from '../pages/News/News';
import { BlogCardPage} from './../pages/BlogCardPage/BlogCardPage';
import { blogCardData } from './../localData/blogCardData';


const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return null;
};


function Router() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <BrowserRouter basename='/'>
      <Analytics />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/nutricao" element={<Nutrition />} />
        <Route path="/exercicios" element={<Exercises />} />
        <Route path="/menteecorpo" element={<MindBody />} />
        <Route path="/produtos" element={<Products />} />
        <Route path="/noticias" element={<News />} />
        {blogCardData.map((post, index) => {
          console.log("post rotas",post)
          const slug = `${post.routeCard}`; // Cria o slug dinâmico
          return (
            <Route
              key={index}
              path={`/${slug}`} // Define o path da rota
              element={<BlogCardPage post={post} />} // Passa o post como prop
            />
          );
        })}
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
